
import { checkObjectFormat, createObjectFormat } from "../../misc/object";
import "../../styles/widgets/widgets.css";
import React, { useState } from "react";

export function FormTableInput({ defaultValue, onChange, reference, format, readonly = false }) {
    const objectFormat = format ? createObjectFormat(format) : null;
    const validation = (event) => {        
        const input = event.target;

        if(objectFormat) {
            const isValid = checkObjectFormat(input.value, objectFormat).ok;

            if(isValid) input.classList.remove("invalid");
            else input.classList.add("invalid");
        }
        
        onChange(event);
    };
    return <input className="input form-table-input" readOnly={readonly} defaultValue={defaultValue}
        onInput={validation} ref={reference} />;
}

export function Checkbox({ defaultValue = false, onChange, className }) {
    const onEventChange = (event) => {
        onChange(event.target.checked);
    };
    return <input type="checkbox" className={className || ""} checked={defaultValue} onChange={onEventChange}/>
}

/**
 * 
 * @param {{ defaultValue, options: { icon: { name: string, height: number, width: number }, label: string, value: string  }[], onSelect: Function }} param0 
 * @returns 
 */
export function Dropdown({ defaultValue, className, disabled, options, onSelect }) {
    let currentValue = defaultValue;
    let selectedOption;
    let firstValue;


    const ref = React.createRef();


    const optionsElements = options.map((option, i) => {
        let iconElement;

        if(option.icon) {
            const { path, width, height } = option.icon;

            const wrapperStyle = {};
            const iconStyle = {};

            if(height) iconStyle.height = height;

            if(width) {
                wrapperStyle.width = width;
                iconStyle.maxWidth = width;
            }

            iconElement = <div className="ddown-optionicon-wrapper" style={wrapperStyle}>
                <img alt="" className="ddown-optionicon" src={path} style={iconStyle} />
            </div>;
        }

        let optionElement;
        
        const onClick = () => {
            // Disable dropdown
            ref.current.classList.remove("selecting")

            // Update field value
            onSelect(value);

            // Update selected value view
            setSelected(optionElement);
        };

        optionElement = <div key={i} className="ddown-optionelement" onClick={onClick}>
            <div className="ddown-optionelement-inner">
                {iconElement || ""}
                <div>{option.label}</div>
            </div>
        </div>;

        const value = option.value;
        if(i===0) firstValue = value;
        if(!selectedOption && currentValue === value) selectedOption = optionElement;

        return optionElement;
    });

    if(!selectedOption) {
        selectedOption = optionsElements[0];
        currentValue = firstValue;
    }


    const [ selected, setSelected ] = useState(selectedOption);
    
    window.addEventListener("click", ({ target }) => {
        const ddown = ref.current;
        if(!ddown) return;
        if(target === ddown && !ddown.classList.contains("selecting")) return ddown.classList.add("selecting");
        ddown.classList.remove("selecting");
    });

    
    // console.log(selected);

    return <div className={`ddown-wrapper ${className || ""}`}>
        <div ref={ref} className={"ddown" + (disabled ? " disabled" : "")}>
            {selected ? React.Children.map(selected.props.children, (element, idx) => {
                // console.log(idx);
                return React.cloneElement(element);
            }) : ""}
        </div>
        <div className="ddown-optionswrapper">{optionsElements}</div>
    </div>;
}